export interface CommitMessageFields {
  title: string
  description: string
}

/** Splits the stored git-style message into its title and optional body. */
export function parseCommitMessage(message?: string): CommitMessageFields {
  const value = message ?? ''
  const newline = value.indexOf('\n')
  if (newline === -1) return { title: value, description: '' }
  return {
    title: value.slice(0, newline),
    description: value.slice(newline + 1).trim()
  }
}

/** Reads the proxy's standard RTK error message envelope with a local fallback. */
export function extractMutationError(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'data' in err) {
    const data = (err as { data?: unknown }).data
    if (data && typeof data === 'object' && 'message' in data) {
      const message = (data as { message?: unknown }).message
      if (typeof message === 'string' && message.length > 0) return message
    }
  }
  return fallback
}
